import { connect } from 'react-redux/dist/react-redux';
import Popup from '../components/Popup';

export default connect()(Popup);
